import React from 'react';
import { getIconUrl } from '../utils';

const ICON_NAME = 'np-cross';

export const Color = {
  WHITE: 'white',
  RED: 'red',
  GREY: 'grey',
  BLACK: 'black',
  DEFAULT: 'white',
};

/**
 * White, Red, Grey, Black X exists in cloudinary, other colors do not.
 * @param {} param0
 */
const X = ({ color = Color.DEFAULT, ...otherProps } = {}) => {
  const url = getIconUrl({
    name: ICON_NAME,
    color,
  });

  return <img {...otherProps} src={url} alt="X Icon" />;
};

export default X;
